import { Link } from 'react-router-dom';
import { getChannel } from '@/mocks/channels';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  accent: 'bg-accent-100 text-accent-800 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-800 border-secondary-200',
};

export function toneClasses(accent: string): string {
  return toneMap[accent] ?? toneMap.primary;
}

export function ChannelPill({
  slug,
  showIcon = true,
}: {
  slug: string;
  showIcon?: boolean;
}) {
  const channel = getChannel(slug);
  if (!channel) return null;
  return (
    <Link
      to={`/channel/${slug}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium whitespace-nowrap transition-colors hover:brightness-95 ${toneClasses(
        channel.accent,
      )}`}
    >
      {showIcon && <i className="ri-fire-fill text-[11px]" aria-hidden="true" />}
      {channel.name}
    </Link>
  );
}